module.exports = __webpack_public_path__ + "assets/img/ic-sync.6a86c58b.svg";